function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2269 13.7995H15.4348L15.154 13.5288C16.1367 12.3856 16.7283 10.9015 16.7283 9.28705C16.7283 5.68711 13.8103 2.76904 10.2103 2.76904C6.61037 2.76904 3.69231 5.68711 3.69231 9.28705C3.69231 12.887 6.61037 15.8051 10.2103 15.8051C11.8248 15.8051 13.3089 15.2134 14.452 14.2307L14.7228 14.5115V15.3037L19.7366 20.3075L21.2308 18.8134L16.2269 13.7995ZM10.1538 13.846C7.6 13.846 5.53846 11.7844 5.53846 9.23058C5.53846 6.67674 7.6 4.6152 10.1538 4.6152C12.7077 4.6152 14.7692 6.67674 14.7692 9.23058C14.7692 11.7844 12.7077 13.846 10.1538 13.846Z",
  fill: "#BABAC8"
});

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.eddd78fe.svg";
export { ForwardRef as ReactComponent };